import React from 'react';
import { NavLink } from 'react-router-dom';

const AddEmployeeCrumb = () => <NavLink to="/human-resources/employees/add">Add Employee</NavLink>;

export default AddEmployeeCrumb;
